import React, { useEffect, useMemo, useState } from "react";

import { api } from "@/lib/api";

export function safeRuntimeFamily(assetId) {
  return "BrandPrivateFont_" + String(assetId || "preview").replace(/[^a-zA-Z0-9_]/g, "_");
}

export default function PrivateFontPreviewV2({
  assetId,
  fileUrl,
  familyLabel,
  primaryText = "Oksana Anokina",
  secondaryText = "Лаборатория превращений",
  compact = false,
  onStatus,
  children,
}) {
  const runtimeFamily = useMemo(() => safeRuntimeFamily(assetId), [assetId]);
  const [ready, setReady] = useState(false);
  const [failed, setFailed] = useState(false);

  useEffect(() => { onStatus?.(assetId, ready ? "ready" : failed ? "error" : "loading"); }, [assetId, ready, failed, onStatus]);

  useEffect(() => {
    let cancelled = false;
    let objectUrl = "";
    let face = null;
    setReady(false);
    setFailed(false);

    if (!fileUrl || typeof FontFace === "undefined") {
      setFailed(true);
      return undefined;
    }

    const mediaPath = fileUrl.replace(/^\/api\/?/, "/");
    api.get(mediaPath, { responseType: "blob" })
      .then(({ data }) => {
        if (!data || cancelled) throw new Error("font asset missing");
        objectUrl = URL.createObjectURL(data);
        face = new FontFace(runtimeFamily, `url("${objectUrl}")`);
        return face.load();
      })
      .then((loaded) => {
        if (cancelled) return;
        document.fonts.add(loaded);
        setReady(true);
      })
      .catch(() => {
        if (!cancelled) setFailed(true);
      });

    return () => {
      cancelled = true;
      if (face && document.fonts?.delete) {
        try { document.fonts.delete(face); } catch {}
      }
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [fileUrl, runtimeFamily]);

  const family = ready ? `"${runtimeFamily}", sans-serif` : "inherit";

  if (children) return <div data-testid="private-font-preview">
    {ready ? children(family) : <p role="status" className="text-[12px] text-[#655141]">{failed ? "Не удалось открыть файл твоего шрифта. Предпросмотр недоступен." : "Загружаю твой шрифт…"}</p>}
  </div>;

  return (
    <div data-testid="private-font-preview">
      <div className="text-[9px] uppercase tracking-[0.14em] text-[#927A5B]">
        {familyLabel || "Свой шрифт"}
      </div>
      <div
        className={compact ? "mt-2 text-[23px] leading-tight text-[#2B211A]" : "mt-3 text-[29px] leading-tight text-[#2B211A]"}
        style={{ fontFamily: family }}
      >
        {primaryText}
      </div>
      <div
        className={compact ? "mt-1.5 text-[15px] text-[#5D4736]" : "mt-2 text-[17px] text-[#5D4736]"}
        style={{ fontFamily: family }}
      >
        {secondaryText}
      </div>
      {!ready && !failed && <div className="mt-2 text-[10px] text-[#9A8066]">Загружаю предпросмотр…</div>}
      {failed && (
        <div className="mt-2 text-[10px] text-[#9A8066]">
          Файл сохранён приватно. Предпросмотр недоступен в этом браузере.
        </div>
      )}
    </div>
  );
}

